__turbopack_context__.v({
  "className": "bricolage_grotesque_b1632670-module__BxEMtG__className",
  "variable": "bricolage_grotesque_b1632670-module__BxEMtG__variable",
});
